/**
 * Filters a list of real-field token entries down to the ones the org has actually mapped
 * (Slack, Addison: "lets only show mapped fields, not all") — `RenameScreen.tsx`'s chip carousel
 * should only offer tokens for fields Field Mapping has a mapping for, not every field on the
 * org's two configured views. "Mapped" is whatever `../mapping/service.ts`'s `getMapping()`
 * already returned (that response is itself pre-filtered server/client-side to non-empty,
 * non-"unmapped" entries), matched by `(view id, field name)` — the same identity pair
 * `MappingEntry.to_view_id`/`to_field_id` carries.
 */

/** Minimal shape this only needs from `RenameScreen.tsx`'s `FlatFieldEntry`. */
export interface MappableEntry {
  view: { id: string };
  field: { name: string };
}

/** Minimal shape this only needs from `../mapping/service.ts`'s `MappingEntry`. */
export interface MappedFieldRef {
  to_view_id: string;
  to_field_id: string;
}

const mappedFieldKey = (viewId: string, fieldName: string): string =>
  `${viewId}::${fieldName}`;

export const filterToMappedFields = <T extends MappableEntry>(
  entries: T[],
  mappedFields: MappedFieldRef[]
): T[] => {
  const mappedKeys = new Set(
    mappedFields.map((f) => mappedFieldKey(f.to_view_id, f.to_field_id))
  );
  return entries.filter((e) =>
    mappedKeys.has(mappedFieldKey(e.view.id, e.field.name))
  );
};
